class BlockListInfoPopupCtrl {
    constructor(BlockListApi, DoclrModalService,praktijkContext,notificationService, $rootScope) {
        'ngInject';

        this.BlockListApi = BlockListApi;
        this.DoclrModalService = DoclrModalService;
        this.praktijkContext = praktijkContext;
        this.notificationService = notificationService;
        this.$rootScope = $rootScope;
    }

    $onInit() {
        this._loadBlockList();
    }

    onUpdate(personBlock) {
        if(personBlock.active){
            this.BlockListApi.setActive(personBlock)
                .then(()=>this._loadBlockList())
                .then(()=>this.$rootScope.$broadcast('$blockListChanged'))
                .then(()=>this.notificationService.showSuccess(doclrVertaal.instant('person.block.active.notification')));
        }else{
            this.BlockListApi.setInActive(personBlock)
                .then(()=>this._loadBlockList())
                .then(()=>this.$rootScope.$broadcast('$blockListChanged'))
                .then(()=>this.notificationService.showSuccess(doclrVertaal.instant('person.block.not.active.notification')));
        }

    }

    onAdd() {
        let newPersonBlock = {
            partyId: this.praktijkContext.id,
            personId: this.person.id,
            active: true,
            blockReason: undefined,
            blockMessage: undefined,
            showBlockMessage: false
        };

        this.DoclrModalService.openAddModal(
            '/partials/patientenbeheer/blocklist/personblock.add.modal.html',
            {
                model:newPersonBlock
            })
            .then(() => this._onApplyAddBlock(newPersonBlock), () => {});
    }


    _onApplyAddBlock(newPersonBlock){
        this.BlockListApi.create(newPersonBlock)
            .then(()=>this._loadBlockList())
            .then(()=>this.$rootScope.$broadcast('$blockListChanged'))
            .then(()=>this.notificationService.showSuccess(doclrVertaal.instant('person.block.added.notification')));
    }

    onDelete(personBlock) {
        this.DoclrModalService.openConfirmModal(doclrVertaal.instant('person.block.delete.title')
                ,doclrVertaal.instant('person.block.delete.question'))
            .then(()=>this.BlockListApi.remove(personBlock.id,personBlock.personId))
            .then(()=>this._loadBlockList())
            .then(()=>this.$rootScope.$broadcast('$blockListChanged'))
            .then(()=>this.notificationService.showSuccess(doclrVertaal.instant('person.block.delete.notification')));
    }


    _loadBlockList(){
        this.BlockListApi
            .findAll(this.person.id)
            .then((blocklist) => this.blocklist = this._sortBlockList(blocklist));
    }

    _sortBlockList(blocklist){
        blocklist.sort(function(x, y) {
            if (x.blockReason < y.blockReason) {
                return -1;
            }
            if (x.blockReason > y.blockReason) {
                return 1;
            }
            return 0;
        });

        return blocklist;
    }
}

(function () {
    'use strict';

    angular.module('doclr.blocklist')
        .component('blockListInfoPopup', {
            templateUrl: '/partials/patientenbeheer/blocklist/block.list.info.popup.component.html',
            controller: BlockListInfoPopupCtrl,
            controllerAs: 'blockListInfoPopupCtrl',
            bindings: {
                person: '<'
            }
        });
})();